import { useState } from "react";
import { useSelector } from "react-redux";
import { FullUserEntity } from "../../../../../entities/ServicesEntities/UserEntities/FullUserEntity";
import { UserAdditionalData } from "../../../../../entities/ServicesEntities/UserEntities/UserAdditionalData";
import { UserIdentityEntity } from "../../../../../entities/ServicesEntities/UserEntities/UserIdentityEntity";
import { UtronUserEntity } from "../../../../../entities/ServicesEntities/UserEntities/UtronUserEntity";
import {
    ADD_PARKER_FORM_STEPS
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import { userActions } from "../../../../../redux/reducers/UserReducer";
import store from "../../../../../redux/Store";
import Strings from "../../../../../resources/Strings";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";
import { handleGmtUserUpdateAfterUserEdit } from "../../../../../services/ParkerService";
import { removePhoneNumberPrefix, getPhoneNumberDialingCodePrefix, phoneNumberToSend} from "../../../../../utils/CommonUtils";
import {
    showErrorMessage,
    showUpdateSuccessMessage
} from "../../../../../utils/MessagesUtils";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import GeneralDetailsStep from "../Steps/GeneralDeatilsStep";
import classes from "../WizardForm.module.css";

const EditGmtDetailsForm = (props) => {
  const selectedSites = useSelector((state) => state.user?.selectedSites);

  const [formData, setFormData] = useState({
    firstName: props?.utronUser?.firstName,
    lastName: props?.utronUser?.lastName,
    dialingCode: getPhoneNumberDialingCodePrefix(props.phoneNumber),
    phoneNumber: removePhoneNumberPrefix(props.phoneNumber),
    originalPhoneNumber: removePhoneNumberPrefix(props.phoneNumber),
    profilePicture:  props?.utronUser?.image,
    isPhoneVerified: true,
    email: props.email,
    notes: props.utronUser?.userAdditionalData.length > 0 ? props.utronUser?.userAdditionalData[0]?.notes : "", 
    isMessagingEnabled: props.utronUser?.userAdditionalData?.length > 0 && props.utronUser?.userAdditionalData[0]?.isMessagingEnabled, 
    isStepSubmitted: false,
    selectedSites: selectedSites
  });

  const [stateData, setStateData] = useState({
    currentStep: ADD_PARKER_FORM_STEPS.GENERAL_DETAILS,
    totalSteps: 1,
    isCurrentStepValid: false,
  });

  const selectedSite = useSelector((state) => state.user?.selectedSite);

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const {
      email,
      firstName,
      lastName,
      dialingCode,
      phoneNumber,
      profilePicture,
      notes,
      isMessagingEnabled
    } = formData;

    let userAdditionalData = {};
    if (props.utronUser?.userAdditionalData.length > 0) {
      // set the existed userAdditionalDate with the new note
      userAdditionalData = { ...props.utronUser.userAdditionalData[0] };
      userAdditionalData.notes = notes; 
      userAdditionalData.isMessagingEnabled = isMessagingEnabled; 
    }
    else {
      // create one if userAdditionalData doesn't exist
      userAdditionalData = new UserAdditionalData(0, 0, props.utronUser.id, null, null, notes, isMessagingEnabled); 
    }

    const utronUser = new UtronUserEntity(
      props.utronUser.id,
      props.id,
      firstName,
      lastName,
      profilePicture?.split(",")[1],
      null,
      null,
      null,
      [userAdditionalData] 
    );
    const userIdentity = new UserIdentityEntity(
      props.id,
      email,
      email,
      dialingCode + phoneNumberToSend(dialingCode, phoneNumber)
    );

    const userToUpdate = new FullUserEntity(
      utronUser,
      userIdentity
    );

    if (stateData.isCurrentStepValid) {
      actionsService.updateUser(userToUpdate).then((response) => {
        if (response.data.isSuccess) {
          store.dispatch(commonActions.closeSideModal()); // close only on success
          store.dispatch(userActions.setUpdatedGmtUser(response.data));
          
          handleGmtUserUpdateAfterUserEdit(props.id, response.data, true, false);
          
          showUpdateSuccessMessage();
        } else {
          showErrorMessage(response.data?.error);
        }
      });
    }
  };

  return (
    <form name="EditGmtGeneralDetails" onSubmit={handleSubmit}>
      <div className={classes.formContainer}>
        <GeneralDetailsStep
          isEditMode={true}
          isGmtDetails={true}
          handleChange={handleChange}
          handleCurrentStepValidity={handleCurrentStepValidity}
          currentStep={stateData.currentStep}
          {...formData}
        />
      </div>
      {stateData.currentStep == stateData.totalSteps && (
        <div className={classes.next}>
          <EllipseButton type="submit">{Strings.SAVE_CHANGES}</EllipseButton>
        </div>
      )}
    </form>
  );
};

export default EditGmtDetailsForm;
